import Card, { GrayInfoCard, InfoCard, InfoCardTitle } from '~/components/Card/Card';

export default Card;

export { GrayInfoCard, InfoCard, InfoCardTitle };
